<template>
  <div style="background-color: #181a1e;display: block;position:relative;">
    <div class="nav-bar" :class="{'is_fixed':isFixed}" v-show="isFixed && isPCandHfive">
      <div style="margin: auto;display: flex; width: 100%;">
        <div class="leftboxline3" style="width: 50%;padding-right: .5208vw;text-align:right;font-siez:1.25vw;"><img src="@/assets/imgs/home/home_logo.png" /> Photosir</div>
        <div style="padding-left: .5208vw; text-align:left; width:50%;">
          <el-button class="leftboxline4btn leftboxline4btn1" @click="goToDownload()">&nbsp;Download PC client&nbsp;</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <!-- 第一屏 -->
      <div class="pagebox">
        <div class="textbox">
          <div class="leftboxline1"><img src="@/assets/imgs/home/home_logo.png" style="vertical-align: bottom;" /> Photosir</div>
          <div class="pageAllBoxTitle2">Smarter, Easier and More Efficient</div>
          <div class="leftboxline3" style="padding-bottom: 2.02vw;">A new generation of photo editor</div>
          <div class="leftboxline4">
            <div style="width: 50%;">
              <div style="padding-left: 0; text-align: center; width:54%;">
                <el-button class="leftboxline4btn leftboxline4btn1" @click="goToDownload()">&nbsp;&nbsp;For PC&nbsp;&nbsp;</el-button>
                <p class="leftboxline4text">A Powerful Alternative to Photoshop;</p>
                <p class="leftboxline4text2">Professional and Safe</p>
              </div>
            </div>
            <div style="width: 50%;">
              <div style="padding-left: 0; text-align: center; width:80%;">
                <el-button class="leftboxline4btn leftboxline4btn2" @click="openSaas()">Buy Now</el-button>
                <p class="leftboxline4text">Common Image Processing Functions for Office Use</p>
                <!-- <p class="leftboxline4text2">No Installation Required</p> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="photobox">
          <img src="https://cdn.yeeheart.com/paramter/home_title.jpg" width="100%" alt="PhotoSir, Alternative to Photoshop, design, cut-out pictures, AIGC, AI painting, video to gif, gif editing, gif compression, gif scaling, gif cropping, pdf to word, picture to word" />
        </div> -->
        <div class="photobox">
          <div class="swiper-container" id="swiperIndex">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,i) in imgs" :key="i">
                <img :src="item.pic" alt="" style="width: 100%;border-radius:25px;">
              </div>
            </div>
            <div class="swiper-pagination">
            </div>
          </div>
        </div>
      </div>
      <div class="firstfloor">
        PhotoSir is a powerful and professional photo editor, which is also a user-friendly alternative to Photoshop. With the brand-new product design and latest built-in AI algorithm, each
        individual user is competent to create their own arts faster and easier. You can deal with 50 billion pixels pictures effortlessly with PhotoSir, what’s more, the software is perfectly
        compatible with PSD. files. PhotoSir provides you with a number of materials and templates, over a hundred types of various brushes, allowing you to create beautiful visuals and no longer
        start from zero 0.
      </div>
      <!-- 第二屏 -->
      <div class="pagebox">
        <div class="photobox1">
          <img width="100%" src="https://cdn.yeeheart.com/paramter/598672516378001408.gif" alt="PhotoSir, Alternative to Photoshop, photoshop crack, open PSD format" />
        </div>
        <div class="textbox1">
          <div class="pageAllBoxTitle1">
            Alternative to Photoshop
          </div>
          <div class="secondrightboxline2">
            <span>90% </span>
            <span class="secondrightboxline2-1"> + </span>
            <span class="secondrightboxline2-2"> coverage of Photoshop Functions </span>
          </div>
          <div class="secondrightboxline2">
            <div style="padding-top: 5.5vw; display: flex;">
              <div style="width: 30%;">
                <p> PSD</p>
                <p class="secondrightboxline2-3"> Read&Write Compatible</p>
              </div>
              <div style="width: 35%;">
                <p>50<span style="font-size:1.25vw;">B</span></p>
                <p class="secondrightboxline2-3">Super-large Pictures</p>
              </div>
              <div style="width: 35%;">
                <p>ICC</p>
                <p class="secondrightboxline2-3"><span style="white-space:nowrap;">Color Configuration</span> Support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三屏 -->
      <div class="pagebox">
        <div class="textbox1" style="display:block;padding-top: 1.6042vw ; padding-left: 1vw; ">
          <div class="pageAllBoxTitle">
            <p>Operate Easily </p>
            <p>Process Effortlessly</p>
          </div>
          <div>
            <div class="pageAllBoxContent3">
              <div style="padding-bottom: 1vw;">
                <img src="@/assets/imgs/home/home_3_icon1.png" width="7%" />&nbsp;&nbsp;Lower Learning Curve
              </div>
              <div style="padding-bottom: 1vw;">
                <img src="@/assets/imgs/home/home_3_icon2.png" width="7%" />&nbsp;&nbsp;Massive Library of Image Resources
              </div>
              <div>
                <img src="@/assets/imgs/home/home_3_icon3.png" width="7%" />&nbsp;&nbsp;One-click AI Functions
              </div>
            </div>
          </div>
        </div>
        <div class="photobox1">
          <img src="https://cdn.yeeheart.com/paramter/home_page3.jpg" width="100%" alt="PhotoSir, Alternative to Photoshop, photoshop crack, open PSD format" />
        </div>
      </div>
      <!-- 第四屏 -->
      <div class="pageAllBox">
        <div class="pageAllBoxTitle">Comprehensive Coverage of Image Processing in Office Scenarios</div>
        <div class="pageAllBoxContent" v-show="isPCandHfive">
          <div>Fast Image Collage</div>
          <div>Batch Processing</div>
          <div>Format Conversion</div>
          <div>AI-powered Tools</div>
        </div>
        <div class="pageAllBoxImgListType">
          <div class="pageAllBoxImgListType2">
            <div style="display:flex;width: 100%;">
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 54" target="_blank" @click="imprint('GWZNPT')"> -->
                <img src="@/assets/imgs/home/home_puzzle_smart.png" class="imgSizeS" alt="Smart collage, PhotoSir, professional image processing, Alternative to Photoshop, piling pictures in order" />
                <li>Smart Collage</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 55" target="_blank" @click="imprint('GWCYPT')"> -->
                <img src="@/assets/imgs/home/home_puzzle_create.png" alt="Creative collage, PhotoSir, Alternative to Photoshop, professional image processing, dealing with irregular shapes"
                     class="imgSizeS" />
                <li>Creative Collage</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 80" target="_blank" @click="imprint('GWTPPJ')"> -->
                <img src="@/assets/imgs/home/image_pho_joint.png" class="imgSizeS" alt="Picture tiling, PhotoSir, professional image processing, Alternative to Photoshop" />
                <li>Picture Tiling</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 95" target="_blank" @click="imprint('GWPLSF')"> -->
                <img src="@/assets/imgs/home/image_zoom.png" class="imgSizeS"
                     alt="Batch picture resizing, PhotoSir, professional image processing, Alternative to Photoshop, photo resizer, photo size" />
                <li>Batch Resize</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 94" target="_blank" @click="imprint('GWPLMM')"> -->
                <img src="@/assets/imgs/home/image_name.png" class="imgSizeS" alt="Batch picture renaming, PhotoSir, professional image processing, Alternative to Photoshop" />
                <li>Batch Rename</li>
                <!-- </a> -->
              </div>
            </div>
          </div>
          <div class="pageAllBoxImgListType2">
            <div style="display:flex;width: 100%;">
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 57" target="_blank" @click="imprint('GWPLSY')"> -->
                <img src="@/assets/imgs/home/image_water.png" class="imgSizeS" alt="Batch watermark, PhotoSir, professional image processing, Alternative to Photoshop, add watermark" />
                <li>Watermark</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 96" target="_blank" @click="imprint('GWPLXZ')"> -->
                <img src="@/assets/imgs/home/image_spin.png" class="imgSizeS" alt="Batch picture rotating, PhotoSir, professional image processing, Alternative to Photoshop" />
                <li>Batch Rotate</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 98" target="_blank" @click="imprint('GWPLZH')"> -->
                <img src="@/assets/imgs/home/image_transition.png" class="imgSizeS"
                     alt="Batch picture format converting, PhotoSir, professional image processing, Alternative to Photoshop, format conversion" />
                <li>Batch Convert</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 56" target="_blank" @click="imprint('GWTPZSP')"> -->
                <img src="@/assets/imgs/home/image_video.png" class="imgSizeS" alt="Convert image to video, PhotoSir, Alternative to Photoshop, professional image processing, photo video editor" />
                <li>Images to Video</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 58" target="_blank" @click="imprint('GWTPZPDF')"> -->
                <img src="@/assets/imgs/home/image_pdf.png" class="imgSizeS"
                     alt="Convert image to pdf, PhotoSir, professional image processing, Alternative to Photoshop, preview pdf, pdf format conversion" />
                <li>PNG to PDF</li>
                <!-- </a> -->
              </div>
            </div>
          </div>
          <div class="pageAllBoxImgListType2">
            <div style="display:flex; width: 100%;">
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 103" target="_blank" @click="imprint('GWPDFZTP')"> -->
                <img src="@/assets/imgs/home/image_pho.png" class="imgSizeS" alt="Convert pdf to image, PhotoSir, professional image processing, Alternative to Photoshop, pdf editor" />
                <li>PDF to Images</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a @click="imprint('GWYJKT')" target="_blank" :href="videoUrl + 101" style="color: #fff"> -->
                <img src="@/assets/imgs/home/image_matting.png" class="imgSizeS"
                     alt="Remove background by one click, PhotoSir, professional image processing, Alternative to Photoshop, cut out hair, cut out portrait" />
                <li>Remove Background</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 135" target="_blank" @click="imprint('GWYJMY')"> -->
                <img src="@/assets/imgs/home/image_beauty.png" class="imgSizeS" alt="Refinement, photo retouching, PhotoSir, professional image processing, Alternative to Photoshop" />
                <li>One Click Beautification</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <!-- <a :href="videoUrl + 137" target="_blank" @click="imprint('GWCFBL')"> -->
                <img src="@/assets/imgs/home/image_resolution.png" class="imgSizeS"
                     alt="Blurred pictures become clearer, small pictures become large pictures, pictures become clear, restore old photos, PhotoSir, professional image processing, Alternative to Photoshop" />
                <li>Super-Resolution</li>
                <!-- </a> -->
              </div>
              <div style="width: 20%;">
                <img src="@/assets/imgs/home/image_ai.png" class="imgSizeS"
                     alt="AIGC, AI Generating Content, AI Painting, AI Creating, PhotoSir, professional image processing, Alternative to Photoshop" />
                <li>AI Creating</li>
              </div>
            </div>
          </div>
        </div>
        <div class="pageAllBoxContent2">Utilize AI and integrated functions to make lightweight image processing achievable with just one click</div>
      </div>
      <!-- 第五屏 -->
      <div class="pagebox">
        <div class="textbox">
          <div style="padding-top: 1.0417vw;width: 80%;">
            <img src="@/assets/imgs/home/image_aigc.png" class="imgSizeS"
                 alt="AIGC, AI Generating Content, AI Painting, AI Creating, stablediffusion, midjourney，controlnet，Artificial Intelligence, PhotoSir, professional image processing, Alternative to Photoshop" />
          </div>
          <div class="pageAllBoxContent4">
            AI painting, with geometric-level efficiency improvement
          </div>
          <div class="pageAllBoxContent5">
            PhotoSir x Flagstudio
          </div>
          <div class="pageAllBoxContent6">
            Cutting-edge artificial intelligence research results, advancing practical applications and implementation in production processes
          </div>
        </div>
        <div class="photobox">
          <img src="https://cdn.yeeheart.com/paramter/image_aigc_pho.jpg" width="100%"
               alt="AIGC, AI Generating Content, AI Painting, AI Creating, stablediffusion, midjourney，controlnet，Artificial Intelligence, PhotoSir, professional image processing, Alternative to Photoshop" />
        </div>
      </div>
      <!-- AI 列表 -->
      <div class="pageAllBox">
        <div class="pageAllBoxImgListType">
          <div class="pageAllBoxImg">
            <div style="width: 50%; ">
              <compare-image class="hot-item__cover imgSizeM" img-original="../../static/images/image_real_picture.JPG" img-result="../../static/images/image_real_picture_other.JPG"
                             alt="Generate PICTURES FROM PICTURES, AIGC, AI Generating Content, AI Painting, AI Creating, stablediffusion, midjourney，controlnet，Artificial Intelligence, PhotoSir, professional image processing, Alternative to Photoshop"></compare-image>
              <div class="pageAllBoxImgp2">Text/Image-to-image generation</div>
            </div>
            <div style="width: 50%; ">
              <compare-image class="hot-item__cover imgSizeM" img-original="../../static/images/image_replace.jpg" img-result="../../static/images/image_replace_other.JPG"
                             alt="Intelligent recognition Filling, AI Recognition Filling, AIGC, AI Generating Content, AI Painting, AI Creating, stablediffusion, midjourney，controlnet，Artificial Intelligence, PhotoSir, professional image processing, Alternative to Photoshop"></compare-image>
              <div class="pageAllBoxImgp2">Partial Replacement</div>
            </div>
          </div>
          <div class="pageAllBoxImg">
            <div style="width: 50%; ">
              <compare-image class="hot-item__cover imgSizeM" img-original="../../static/images/image_division.JPG" img-result="../../static/images/image_division_other.JPG"
                             alt="Semantic segmentation, segment， AIGC, AI Generating Content, AI Painting, AI Creating, stablediffusion, midjourney，controlnet，Artificial Intelligence, PhotoSir, professional image processing, Alternative to Photoshop"></compare-image>
              <div class="pageAllBoxImgp2">Semantic Segmentation <br />&nbsp;</div>
            </div>
            <div style="width: 50%; ">
              <compare-image class="hot-item__cover imgSizeM" img-original="../../static/images/image_sketch.JPG" img-result="../../static/images/image_sketch_other.JPG"
                             alt="Sketch-to-painting Conversion, AIGC, AI Generating Content, AI Painting, AI Creating, stablediffusion, midjourney，controlnet，Artificial Intelligence, PhotoSir, professional image processing, Alternative to Photoshop"></compare-image>
              <div class="pageAllBoxImgp2">Sketch-to-painting Conversion</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第六屏 -->
      <div class="pageAllBox">
        <div class="pageAllBoxTitle">Rich Features to Make your Arts Shine</div>
        <div class="pageAllBoxImgListType">
          <div class="pageAllBoxImg">
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_colour.jpg" class="imgSizeM"
                   alt="color configuration, color management, CMYK, RGB, printing, PhotoSir, professional image processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Color Management</span>
                <li>ICC color configuration, RGB/CMYK support</li>
                <div class="pageAllBoxImgli2">Supports color configuration space management, RGB and CMYK modes, and various professional scenarios.</div>
              </div>
            </div>
            <div style="width: 50%; ">
              <img src="@/assets/imgs/home/image_layout.jpg" class="imgSizeM"
                   alt="psd format, raw format, pdf format, eps format, svg format, jpg format, png format, webp format, bmp format, PhotoSir, professional image processing, Alternative to Photoshop " />
              <div class="imgSizeM">
                <p></p>
                <span> Multi-format Support</span>
                <li>Supports a wide range of image formats including RAW</li>
                <div class="pageAllBoxImgli2">Supports up to 50 different formats, easily handling various types of issues.&emsp;&emsp;&emsp;&emsp;&emsp; &emsp;&emsp;&emsp;</div>
              </div>
            </div>
          </div>
          <div class="pageAllBoxImg">
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_brush.jpg" class="imgSizeM"
                   alt="Hand-drawing, original game drawing, illustration, drawing tablets, pressure-sensitive，sai，procreate, PhotoSir, professional image processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Perfect Brush Experience</span>
                <li>Support for mainstream drawing tablets &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</li>
                <div class="pageAllBoxImgli2">107 built-in brushes, with dozens of advanced parameters that can be adjusted to define your own brush.</div>
              </div>
            </div>
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_object.jpg" class="imgSizeM"
                   alt="layers, layer styles, layer masks, clipping masks, channels, PhotoSir, Professional Image Processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Powerful Object Layers</span>
                <li>Unleashes your imagination &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</li>
                <div class="pageAllBoxImgli2">Adjust layer, mask layer, and layer styles to achieve any effect you desire.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pageAllBoxImgListType">
          <div class="pageAllBoxImg">
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_toning.jpg" class="imgSizeM"
                   alt="Professional color correction, raw format color correction, curves, color scale, hue, PhotoSir, Professional Image Processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Professional Color Correction</span>
                <li>Curves/Tone/Saturation <br>&emsp;</li>
                <div class="pageAllBoxImgli2"> Use color correction functions such as curves, tone, and saturation to make colors more stunning.</div>
              </div>
            </div>
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_filter.jpg" class="imgSizeM"
                   alt="Special Effects Filter, water ripple, wind blow, blur, stylization, PhotoSir, Professional Image Processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Various Special Effect Filters</span>
                <li>Combines a variety of effects and filters </li>
                <div class="pageAllBoxImgli2">In addition to conventional effects, powerful effects such as hand-painted and scanned document repair are also included.</div>
              </div>
            </div>
          </div>
          <div class="pageAllBoxImg">
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_vector.jpg" class="imgSizeM" alt="Eps format, svg format, vector editing, PhotoSir, Professional Image Processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Vector Format Editing &emsp;</span>
                <li>Vector files can be adjusted directly by paths</li>
                <div class="pageAllBoxImgli2">Tiangong Material Library has a massive collection of vector materials, making it more convenient to use. <br> &emsp;</div>
              </div>
            </div>
            <div style="width: 50%;">
              <img src="@/assets/imgs/home/image_electorate.jpg" class="imgSizeM" alt="Content Recognition, Selection, PhotoSir, Professional Image Processing, Alternative to Photoshop" />
              <div class="imgSizeM">
                <p></p>
                <span>Flexible Selection Tools</span>
                <li>Magic wand, lasso, path with multiple parameters to choose from</li>
                <div class="pageAllBoxImgli2" style="padding-top:0;">Various selection tools and parameters help achieve more accurate selections.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="pageAllBox" >
        <div class="pageAllBoxTitle1" >国内外系统支持</div>
        <div class="pageAllBoxContent1" >全面支持国内信创操作系统</div>
        <div>
          <div class="pageAllBoxImg">
            <div style="width: 20%">
              <img src="@/assets/imgs/home/image_window.png" class="imgSizeS"  alt="windows，悟空图像，专业图像处理，国产PS，photoshop" />
              <p>windows</p>
            </div>
            <div style="width: 20%">
                <img src="@/assets/imgs/home/image_macOS.png" class="imgSizeS" alt="macOs，悟空图像，专业图像处理，国产PS，photoshop" />
                <p>macOS</p>
            </div>
            <div style="width: 20%">
                <img src="@/assets/imgs/home/image_qilin.png" class="imgSizeS" alt="麒麟，信创系统，信创软件，悟空图像，专业图像处理，国产PS，photoshop"/>
                <p>麒麟</p>
            </div>
            <div style="width: 20%">
                <img src="@/assets/imgs/home/image_tx.png" class="imgSizeS"  alt="统信，信创系统，信创软件，悟空图像，专业图像处理，国产PS，photoshop" />
                <p>统信</p>
            </div>
            <div style="width: 20%">
                <img src="@/assets/imgs/home/image_fd.png" class="imgSizeS" alt="方德，信创系统，信创软件，悟空图像，专业图像处理，国产PS，photoshop" />
                <p>方德</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import CompareImage from '@/components/CompareImage.vue'
import { getVisit, saveloginrecord } from '../utils/api'
import 'swiper/css/swiper.css'  //引入swiper样式
import Swiper from 'swiper';	//引入swiper
export default {
  name: "photosircom",
  title: "悟空图像官网",
  props: {},
  data() {
    return {
      isPCandHfive: true,
      isFixed: false,
      videoUrl: 'https://www.yeeheart.com/#/VideosDetails?videosId=',
      imgs: [
        { pic: 'https://cdn.yeeheart.com/paramter/670092026917683201.jpg' },
        { pic: 'https://cdn.yeeheart.com/paramter/home_title.jpg' }
      ]
    }
  },
  components: { CompareImage },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-RFBJDTX60Q');
    var mySwiper = new Swiper('#swiperIndex', {
      //配置分页器内容
      autoplay: true, //自动轮播
      loop: true, // 循环模式选项
      pagination: {
        el: ".swiper-pagination",//换页器与哪个标签关联
        clickable: true//分页器是否可以点击
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      //如果需要滚动条
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
  },
  destroyed() {
    // 销毁，其他页面也会加载，浪费资源
    // true是捕获，false是冒泡
    window.removeEventListener('scroll', this.initHeight, false)
  },
  methods: {
    initHeight() {
      // 各种浏览器的滑动偏移参数获取
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isFixed = scrollTop > 152
    },
    goToDownload() {
      this.$router.push('/Download')
    },
    openSaas() {
      this.$emit('buyPath', 'Buy');
    },
    imprint(e) {
      var thcode
      if (
        this.$route.query.thcode !== undefined &&
        this.$route.query.thcode !== null &&
        this.$route.query.thcode !== ''
      ) {
        thcode = this.$route.query.thcode
      } else {
        thcode = e
      }
      let param = {
        thcode: thcode,
        source: 3
      }
      getVisit(param).then(res => {
      })
    },
  },
  created() {
    if (this.$route.query.type == 'login') {
      let param = {
        source: 3
      }
      saveloginrecord(param).then(res => {
        // console.log(res)
      })
    }
    this.imprint('GW')
    // 判断设备  手机/电脑
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (!flag) {
      // console.log('电脑')
      this.isPCandHfive = true
    } else {
      this.isPCandHfive = false
    }
  }
}
</script>
<style scoped >
  @media screen and (min-width: 700px) {
    .main {
      position: relative;
      width: 70vw;
      margin: auto;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    }
    .pagebox {
      width: 100%;
      display: flex;
      padding-top: 2.52vw;
      padding-bottom: 5.52vw;
    }
    .textbox {
      width: 40%;
      display: block;
    }
    .photobox {
      width: 60%;
      margin: auto;
    }
    .textbox1 {
      width: 30%;
      display: block;
      margin: auto;
    }
    .photobox1 {
      width: 70%;
      margin: auto;
    }
    .pageAllBoxImgListType {
      display: flex;
    }
    .pageAllBoxImgListType2 {
      display: flex;
      width: 33%;
    }
    .pageAllBoxImg {
      display: flex;
      justify-content: space-around;
      padding-top: 3vw;
      padding-bottom: 1.52vw;
      width: 50%;
      margin: auto;
      text-align: left;
    }
    .hot-item__cover {
      min-width: 13.5417vw;
      min-height: 9.375vw;
      /* margin: auto; */
    }
    .pageAllBoxTitle {
      font-size: 1.875vw;
      font-weight: 400;
      color: #ffffff;
      padding-top: 1.52vw;
      padding-bottom: 3.52vw;
    }
    .pageAllBoxTitle1 {
      font-size: 1.875vw;
      font-weight: 400;
      color: #ffffff;
      padding-top: 1.52vw;
      padding-bottom: 1.02vw;
    }
    .leftboxline1 {
      font-size: 1.25vw;
      font-weight: 700;
      color: #9e9e9e;
    }
    .pageAllBoxTitle2 {
      font-size: 1.875vw;
      font-weight: 400;
      color: #ffffff;
      padding-top: 1.52vw;
      padding-bottom: 1.02vw;
    }
    .leftboxline2 {
      padding-top: 2.2vw;
      font-size: 2.071vw;
      font-weight: 700;
      color: #ffffff;
    }
    .leftboxline3 {
      font-size: 1.4583vw;
      font-weight: 400;
      color: #ffffff;
      color: #9e9e9e;
    }
    .pageAllBoxContent {
      display: flex;
      font-size: 1.25vw;
      font-weight: 400;
      color: #9e9e9e;
      justify-content: space-around;
      padding-bottom: 1.52vw;
    }
    .pageAllBoxContent1 {
      display: flex;
      font-size: 0.0625rem;
      font-weight: 400;
      color: #9e9e9e;
      justify-content: space-around;
      padding-bottom: 1.52vw;
    }
    .pageAllBoxContent2 {
      display: flex;
      font-size: 1.0417vw;
      font-weight: 400;
      color: #ffffff;
      justify-content: space-around;
      padding-bottom: 1.52vw;
      padding-top: 5.52vw;
    }
    .pageAllBoxContent3 {
      font-size: 1vw;
      color: #dedede;
      font-weight: 350;
      padding-top: 5.5vw;
      padding-bottom: 2vw;
    }
    .pageAllBoxContent4 {
      font-size: 1.667vw;
      color: #ffffff;
      font-weight: 400;
      width: 80%;
      padding-top: 1.0417vw;
    }
    .pageAllBoxContent5 {
      font-size: 0.625vw;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 1.0417vw;
      width: 80%;
    }
    .pageAllBoxContent6 {
      font-size: 1.25vw;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 5.5417vw;
      padding-bottom: 2.0417vw;
      width: 80%;
    }
    .pageAllBoxImg span {
      font-size: 1.4583vw;
      font-weight: 700;
      color: #ffffff;
    }
    .pageAllBoxImg li {
      font-size: 0.9375vw;
      font-weight: 400;
      color: #9e9e9e;
      text-align: left;
      padding-top: 1.02vw;
      padding-bottom: 2vw;
      height: 6vw;
    }
    .pageAllBoxImgli2 {
      font-size: 0.7292vw;
      font-weight: 400;
      color: #9e9e9e;
      text-align: left;
      margin-top: 2vw;
      padding-bottom: 2vw;
      height: 8vw;
    }
    .pageAllBoxImgListType2 li {
      color: #9e9e9e;
      font-size: 0.625vw;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 1vw;
      padding-bottom: 2vw;
    }
    .pageAllBoxImg p {
      font-size: 0.625vw;
      padding-top: 1.0729vw;
      color: #9e9e9e;
    }
    .pageAllBoxImgp2 {
      font-size: 1.1458vw;
      padding-top: 1.0729vw;
      color: #9e9e9e;
      width: 80%;
      text-align: center;
    }
    .leftboxline4 {
      padding-top: 1.52vw;
      display: flex;
    }
    .leftboxline4btn {
      color: #ffffff;
      border: 0;
      font-weight: 400;
      font-size: 1.0617vw;
    }
    .leftboxline4text {
      font-size: 0.692vw;
      font-weight: 350;
      color: #d1d1d1;
      padding-top: 1.52vw;
    }
    .leftboxline4text2 {
      font-size: 0.625vw;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 0;
    }
    .firstfloor {
      font-size: 0.7292vw;
      width: 100%;
      font-weight: 400;
      color: #9e9e9e;
    }
    .secondrightboxline1 {
      font-size: 2.0833vw;
      font-weight: 400;
      color: #ffffff;
    }
    .secondrightboxline2 {
      font-size: 1.875vw;
      font-weight: 700;
      color: #ffffff;
    }
    .secondrightboxline2-1 {
      font-size: 1.4583vw;
      color: #ff4d4d;
      font-weight: 900;
    }
    .secondrightboxline2-2 {
      font-size: 1.5625vw;
      font-weight: 350;
    }
    .secondrightboxline2-3 {
      font-size: 0.9896vw;
      font-weight: 500;
    }
  }
  @media screen and (max-width: 700px) {
    .main {
      position: relative;
      width: 85vw;
      margin: auto;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    }
    .pagebox {
      width: 100%;
      display: block;
      padding-top: 1.52vw;
      padding-bottom: 5.52vw;
    }
    .textbox {
      width: 100%;
      display: block;
      margin: auto;
    }
    .photobox {
      width: 100%;
      margin: auto;
    }
    .textbox1 {
      width: 100%;
      display: block;
      margin: auto;
    }
    .photobox1 {
      width: 100%;
      margin: auto;
    }
    .pageAllBoxImgListType {
      display: block;
    }
    .pageAllBoxImgListType2 {
      display: block;
      width: 100%;
    }
    .pageAllBoxImg {
      display: flex;
      justify-content: space-around;
      padding-bottom: 1.52vw;
      width: 100%;
      margin: auto;
    }
    .imgSizeM {
      margin: auto;
    }
    .hot-item__cover {
      min-width: 130px;
      min-height: 90px;
      margin: auto;
    }
    .pageAllBoxTitle {
      font-size: 28px;
      font-weight: 400;
      color: #ffffff;
      padding-top: 1.52vw;
      padding-bottom: 3.52vw;
    }
    .pageAllBoxTitle1 {
      font-size: 28px;
      font-weight: 400;
      color: #ffffff;
      padding-top: 1.52vw;
      padding-bottom: 1.02vw;
    }
    .pageAllBoxTitle2 {
      font-size: 26px;
      font-weight: 400;
      color: #ffffff;
      padding-top: 1.52vw;
      padding-bottom: 1.02vw;
    }
    .leftboxline1 {
      padding-top: 3.2vw;
      font-size: 20px;
      font-weight: 700;
      color: #9e9e9e;
    }
    .leftboxline3 {
      font-size: 22px;
      font-weight: 400;
      color: #ffffff;
    }
    .pageAllBoxContent {
      display: flex;
      font-weight: 400;
      color: #9e9e9e;
      justify-content: space-around;
      padding-bottom: 1.52vw;
    }
    .pageAllBoxContent1 {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      color: #9e9e9e;
      justify-content: space-around;
      padding-bottom: 1.52vw;
    }
    .pageAllBoxContent2 {
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      justify-content: space-around;
      padding-bottom: 1.52vw;
      padding-top: 5.52vw;
    }
    .pageAllBoxContent3 {
      font-size: 16px;
      color: #dedede;
      font-weight: 350;
      padding-top: 5.5vw;
      padding-bottom: 2vw;
    }
    .pageAllBoxContent4 {
      font-size: 22px;
      color: #ffffff;
      font-weight: 400;
      width: 80%;
      padding-top: 1.0417vw;
    }
    .pageAllBoxContent5 {
      font-size: 11px;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 1.0417vw;
      width: 80%;
    }
    .pageAllBoxContent6 {
      font-size: 16px;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 5.5417vw;
      padding-bottom: 2.0417vw;
      width: 80%;
    }
    .pageAllBoxImg span {
      text-align: left;
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
    }
    .pageAllBoxImg li {
      font-size: 14px;
      font-weight: 400;
      color: #9e9e9e;
      text-align: left;
      padding-top: 1.02vw;
      padding-bottom: 2vw;
    }
    .pageAllBoxImgli2 {
      font-size: 12px;
      font-weight: 400;
      color: #9e9e9e;
      text-align: left;
      padding-top: 1.02vw;
      padding-bottom: 2vw;
    }
    .pageAllBoxImgListType2 li {
      color: #9e9e9e;
      font-size: 11px;
      font-weight: 350;
      padding-top: 1vw;
      padding-bottom: 2vw;
    }
    .pageAllBoxImg p {
      font-size: 11px;
      padding-top: 1.0729vw;
      color: #9e9e9e;
    }
    .pageAllBoxImgp2 {
      font-size: 16px;
      padding-top: 1.0729vw;
      color: #9e9e9e;
    }
    .leftboxline4 {
      padding-top: 4vw;
      display: flex;
    }
    .leftboxline4btn {
      color: #ffffff;
      border: 0;
      font-weight: 400;
      font-size: 16px;
    }
    .leftboxline4text {
      font-size: 12px;
      font-weight: 350;
      color: #d1d1d1;
      padding-top: 1.52vw;
    }
    .leftboxline4text2 {
      font-size: 11px;
      font-weight: 350;
      color: #9e9e9e;
      padding-top: 1.52vw;
    }
    .firstfloor {
      font-size: 12px;
      width: 100%;
      font-weight: 400;
      color: #9e9e9e;
    }
    .secondrightboxline1 {
      font-size: 28px;
      font-weight: 400;
      color: #ffffff;
    }
    .secondrightboxline2 {
      font-size: 26px;
      font-weight: 700;
      color: #ffffff;
    }
    .secondrightboxline2-1 {
      font-size: 22px;
      color: #ff4d4d;
      font-weight: 900;
    }
    .secondrightboxline2-2 {
      font-size: 20px;
      font-weight: 350;
    }
    .secondrightboxline2-3 {
      font-size: 12px;
      font-weight: 500;
    }
  }
  .pageAllBox {
    display: block;
    text-align: center;
    width: 100%;
    padding-top: 1.52vw;
    padding-bottom: 5.52vw;
  }
  .imgSizeS {
    width: 50%;
    margin: auto;
  }
  .imgSizeM {
    position: relative;
    width: 80%;
    display: flex;
    flex-wrap: wrap;
  }
  .leftboxline4btn1 {
    border: 1px solid #257cff;
    background-color: #257cff;
  }
  .leftboxline4btn2 {
    border: 1px solid #ffffff;
    background-color: #181a1e;
  }
  .nav-bar {
    height: 50px;
    line-height: 50px;
    z-index: 10;
  }
  .is_fixed {
    position: fixed;
    display: flex;
    background-color: #1c1e21;
    top: 50px;
    width: 100%;
  }
</style>
<style lang="scss">
  .swiper-pagination {
    .swiper-pagination-bullet {
      background-color: #eeeeee;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/PhotoSir.vue